import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App";
import "./index.css";

// Versiunea intra si in bundle, nu doar in `<meta name="app-version">`: asa
// fiecare release produce un `index-<hash>.js` cu ALT nume, chiar daca restul
// codului nu s-a schimbat. Conteaza la recuperare: un browser care a prins in
// cache un 404 „imutabil" pentru bundle-ul unei versiuni (INC 2026-09-04,
// zonedelivery) il tine un an, iar singura cale prin care pagina se repara
// singura e un URL nou. Linia e si un reper de suport: versiunea se vede in
// consola fara sa cauti in surse.
console.info(`deliveryapp-web v${import.meta.env.VITE_APP_VERSION}`);

const container = document.getElementById("root");
if (container === null) {
  // Fara punctul de montare nu exista nimic de aratat si niciun loc unde sa
  // scriem mesajul. Aruncam, ca esecul sa apara in consola si in raportarea de
  // erori, nu ca pagina alba fara explicatie.
  throw new Error("Elementul #root lipseste din document; aplicatia nu poate porni.");
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
